<template>
  <div class="shop-settings-password">
    <v-row>
      <v-col cols="12" v-if="!getIsSubscribed">
        <v-alert text color="info" outlined>
          <v-row align="center" dense>
            <v-col cols="12" class="title black--text">
              Your subscription isn't active yet.
              <transition name="fade">
                <div v-if="error" class="body-2"
                  >Something went wrong. Please try again or email
                  <a href="mailto:hi@getminimart.com">hi@getminimart.com</a
                  >.</div
                >
              </transition>
            </v-col>
            <v-col cols="12">
              <BtnBaseOrange
                @click="requestSubscriptionCheckoutUrl"
                :loading="loading"
                >Subscribe</BtnBaseOrange
              >
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <v-col v-else>
        <transition
          name="fade"
          mode="out-in"
          @enter="scrollToCancelationMessage"
        >
          <v-alert
            v-if="success"
            text
            type="success"
            outlined
            :id="successMessageId"
          >
            <div class="title">Sorry to see you go!</div>
            <div
              >Your request has been received and will be processed within 24
              hours.</div
            >
          </v-alert>
          <BtnBaseBlue
            v-else
            @click="submitCancelationRequest"
            :loading="loading"
            depressed
            outlined
            class="d-inline"
            color="blue darken-2 white--text"
            >Request Cancelation
          </BtnBaseBlue>
        </transition>
        <transition name="fade">
          <div v-if="error" class="body-2"
            >Something went wrong. Please try again or email
            <a href="mailto:hi@getminimart.com">hi@getminimart.com</a>.</div
          >
        </transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ShopModel from '@/models/ShopModel'
import _get from 'lodash/get'

import BtnBaseBlue from '@/components/BtnBaseBlue'
import BtnBaseOrange from '@/components/BtnBaseOrange'
export default {
  name: 'ShopSettingsCancelSubscription',
  components: { BtnBaseBlue, BtnBaseOrange },
  data() {
    return {
      loading: false,
      checkoutUrl: null,
      error: null,
      success: false,
      successMessageId: 'cancelation-success',
    }
  },
  methods: {
    ...mapActions('shop', ['requestCancelation']),
    async requestSubscriptionCheckoutUrl() {
      this.loading = true
      this.error = null
      try {
        let response = await ShopModel.getSubscriptionCheckoutUrl(
          this.getShopId
        )
        let urlObj = _get(response, 'response.data.data', {})

        this.checkoutUrl = urlObj.checkoutUrl
        window.location.href = this.checkoutUrl
      } catch (error) {
        this.loading = false
        this.error = error
      }
    }, // requestSubscriptionCheckoutUrl
    async submitCancelationRequest() {
      this.loading = true
      this.error = null
      this.success = false

      try {
        await this.requestCancelation(this.getShopId)
        this.success = true
        setTimeout(() => {
          this.success = false
        }, 10000)
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    }, // submitCancelationRequest
    scrollToCancelationMessage(el) {
      if (el.id === this.successMessageId) {
        this.$scrollTo(`#${this.successMessageId}`, 700, { offset: -48 })
      }
    }, // scrollToCancelationMessage
  },
  computed: {
    ...mapGetters('shop', ['getShopId', 'getIsSubscribed']),
  },
}
</script>
